export default "__VITE_ASSET__C3JsmEM4__"